/** Mensaje de error que devuelve el backend (`{ error }`), o uno por defecto. */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = (error as { response?: { data?: { error?: unknown } } } | null)?.response?.data;
  return typeof data?.error === "string" && data.error.trim() ? data.error : fallback;
};
